import { render, staticRenderFns } from "./KCImageCropper.vue?vue&type=template&id=704d3212&"
import script from "./KCImageCropper.vue?vue&type=script&lang=js&"
export * from "./KCImageCropper.vue?vue&type=script&lang=js&"
import style0 from "./KCImageCropper.vue?vue&type=style&index=0&id=704d3212&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports